import { eventTimeline } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function TimelineSection() {
  return (
    <section id="timeline" className="py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <span className="text-xs font-medium tracking-[0.2em] text-primary-600">
                事件脉络梳理
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                {eventTimeline.title}
              </h2>
              <p className="mt-4 text-[15px] leading-8 text-foreground-700">
                {eventTimeline.subtitle}
              </p>
              <a
                href="#ranking"
                className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-git-branch-line text-base" />
                查看完整时间线
              </a>
            </div>
          </Reveal>

          <div className="relative">
            <div className="absolute bottom-2 left-[15px] top-2 w-px bg-background-300" />
            <ol className="flex flex-col gap-8">
              {eventTimeline.steps.map((step, index) => (
                <Reveal key={step.time} delay={index * 90}>
                  <li className="relative flex gap-5">
                    <span
                      className={`relative z-10 mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-xs font-bold ${
                        index === eventTimeline.steps.length - 1
                          ? 'border-primary-500 bg-primary-500 text-background-50'
                          : 'border-background-300 bg-background-50 text-foreground-700'
                      }`}
                    >
                      {index + 1}
                    </span>
                    <div className="flex-1 pb-1">
                      <div className="flex flex-wrap items-center gap-3">
                        <span className="text-xs font-medium tracking-wide text-foreground-500">
                          {step.time}
                        </span>
                        <span className="rounded-md bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">
                          {step.tag}
                        </span>
                      </div>
                      <h3 className="mt-2.5 font-heading text-lg font-bold text-foreground-950">
                        {step.title}
                      </h3>
                      <p className="mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
                        {step.desc}
                      </p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}